var exports = {
  "spinner": "Spinner.module__spinner___TGtpMH",
  "spinnerInner": "Spinner.module__spinnerInner___TGtpMH",
  "spinnerItem": "Spinner.module__spinnerItem___TGtpMH",
  "spinnerPulsingEllipsis": "Spinner.module__spinnerPulsingEllipsis___TGtpMH",
  "small": "Spinner.module__small___TGtpMH",
  "medium": "Spinner.module__medium___TGtpMH",
  "large": "Spinner.module__large___TGtpMH",
  "delay1": "Spinner.module__delay1___TGtpMH",
  "delay2": "Spinner.module__delay2___TGtpMH",
  "srOnly": "Spinner.module__srOnly___TGtpMH",
};

__webpack_require__.r(module.exports = exports);
